module.exports = __webpack_public_path__ + "media/components/Builder/Library/Images/ChevronBlackDown-cf00fb004680c16d78c5135487f07243.png";